import { Component, OnInit } from '@angular/core';

@Component({
    standalone: false,
    selector: 'particle-collaboration-content',
  templateUrl: './collaboration-content.component.html',
  styleUrls: ['./collaboration-content.component.css']
})
export class CollaborationContentComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
